<template>
  <div class="screenfull" @click="click">
    <span class="screenfull_icon icon-zhankai" :class="{'icon-shouqi': isFullscreen}" />
    <span>{{isFullscreen?$ts('全屏'):$ts('正常')}}</span>
  </div>
</template>

<script>
  import screenfull from 'screenfull'
  export default {
    name: 'Screenfull',
    data() {
      return {
        isFullscreen: false
      }
    },
    mounted() {
      this.init()
    },
    beforeDestroy() {
      this.destroy()
    },
    methods: {
      click() {
        if (!screenfull.isEnabled) {
          this.$message({
            message: 'you browser can not work',
            type: 'warning'
          })
          return false
        }
        screenfull.toggle()
      },
      change() {
        this.isFullscreen = screenfull.isFullscreen
      },
      init() {
        if (screenfull.isEnabled) {
          screenfull.on('change', this.change)
        }
      },
      destroy() {
        if (screenfull.isEnabled) {
          screenfull.off('change', this.change)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .screenfull {
    display: inline-block;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #333333;
    border-radius: 25px;
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    background-color: #f5f5f5;
    border: solid 1px #e5e5e5;
    cursor: pointer;
    user-select: none;

    &_icon {
      cursor: pointer;
      width: 20px;
      height: 20px;
      color: #333;
      font-family: 'iconfont';
      margin-right: 6px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar/Screenfull.vue